<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width  h-full'>
         <div class="banner_gruop">
            <div class="banner_title"> <span class="color3"></span> Our Mission & Vision</div>
            <div class="banner_tips mt-40 fw-300">At Minglepay, we’re building the ultimate financial toolkit for the modern internet era. Our mission is to replace outdated legacy systems, eliminating delays, intermediaries, manual errors, and systemic biases. We envision a world where payments flow instantly </div>     
          </div>
          <div class="call_grid border-focus">
            <div class="call_item px-20 py-40">
              <div class="color8 fs-f40">Global Reach</div>
              <div class="color1 mt-10 fw-400 fs-f16">Seamless transactions anywhere, anytime.</div>
            </div>
            <div class="call_item px-20 py-40">
              <div class="color8 fs-f40">Empowered Users</div>
              <div class="color1 mt-10 fw-400 fs-f16">Your data, your control, no gatekeepers.</div>
            </div>
            <div class="call_item px-20 py-40">
              <div class="color8 fs-f40">Frictionless Finance</div>
              <div class="color1 mt-10 fw-400 fs-f16">Fast, transparent, and cost-effective solutions.</div>
            </div>
          </div>
         <div class="page_title mt-100">
            <div class="title_name color1">Driving Financial Transformation</div>
            <div class="title_tag color1">We’re revolutionizing finance through open banking. Our goal is to create a system where payments are instant, borders are irrelevant, and financial insights are accessible to all—not just banks.</div>
          </div>
       </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color2">The Minglepay Culture: Our Core Pillars</div>
            <div class="title_tag color6">Our culture is built on three foundational principles that guide everything we do</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb39.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Innovation</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Constantly pushing fintech boundaries.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb40.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Transparency</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Building trust through open, honest, and clear processes.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9" >
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb41.png" alt="" class="">
                        </div>
                        <div class="half_title color2">Inclusivity</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Creating solutions that empower everyone, everywhere.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container bg-6 page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">Our Secret Sauce</div>
                <div class="title_tag color1 flex_center">What sets Minglepay apart? It’s our relentless focus on simplicity, speed, and user empowerment. We combine cutting-edge technology with a deep understanding of global financial needs to deliver solutions that work for you, not against you.</div>
            </div>
        </div>
    </div>
  

    
    <div class="container pb-80"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">What We Offer</div>
                <div class="title_tag color6">Minglepay provides a suite of payment solutions designed for both online and in-person transactions, ensuring a seamless omnichannel experience for your customers. From instant payouts to smart routing, our products are built to simplify and enhance every transa</div>
            </div>
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_col_start" >
                    <div class="tab_left text-l p-20 h-100p " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Online & In-Store</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Unified payment experiences across all channels.</div>
                    </div>
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Fast & Secure</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Cutting-edge tech for reliable, protected transactions.</div>
                    </div>
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Global Flexibility</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Support for 100+ currencies and 55+ countries.</div>
                    </div>
                </div>
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t56.png" alt="">
                  </div>
                </div>
              </div>
          </div>
          
        </div>
      </div>
    </div>
   
  
    
    

  
  </div>
</template>

<script>


export default {
    data(){
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg10.png);
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.call_grid{
  background:rgba(255, 255, 255,0.3);
  position: relative;
  &::before{
    content:'';
    width: 2px;
    height: calc(100% - 80px);
    background:#fff;
    top:40px;
    left:33.33%;
    position: absolute;
  }
   &::after{
    content:'';
    width: 2px;
    height: calc(100% - 80px);
    background:#fff;
    top:40px;
    right:33.33%;
    position: absolute;
  }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.h-full{
  height: 950px;
}
@media screen and (max-width:767px){
  .h-full{
    height: 600px;
  }
  .page_title{
    margin-top:50px;
  }
  .call_grid{
    >div{
      padding:20px;
    }
  }
}
</style>